var _path, _path2, _path3, _g, _path4, _defs, _mask, _path5, _path6, _path7, _defs2, _mask2, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.307 313.094",
    enableBackground: "new 0 0 511.307 313.094",
    xmlSpace: "preserve",
    width: 85,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#539E43",
    d: "M252.879,313.094c-1.734,0-3.352-0.462-4.854-1.271l-15.372-9.13c-2.312-1.271-1.156-1.734-0.462-1.965 c3.121-1.04,3.698-1.271,6.935-3.121c0.347-0.231,0.809-0.116,1.156,0.116l11.789,7.05c0.462,0.231,1.04,0.231,1.387,0 l46.115-26.698c0.462-0.231,0.693-0.693,0.693-1.271v-53.28c0-0.578-0.231-1.04-0.693-1.271l-46.115-26.582 c-0.462-0.231-1.04-0.231-1.387,0l-46.115,26.582c-0.462,0.231-0.693,0.809-0.693,1.271v53.28c0,0.462,0.231,1.04,0.693,1.271 l12.598,7.281c6.819,3.467,11.095-0.578,11.095-4.623v-52.587c0-0.693,0.578-1.387,1.387-1.387h5.894 c0.693,0,1.387,0.578,1.387,1.387v52.587c0,9.13-4.97,14.447-13.638,14.447c-2.658,0-4.739,0-10.633-2.889l-12.135-6.935 c-3.005-1.734-4.854-4.97-4.854-8.437v-53.28c0-3.467,1.849-6.703,4.854-8.437l46.115-26.698c2.889-1.618,6.819-1.618,9.708,0 l46.115,26.698c3.005,1.734,4.854,4.97,4.854,8.437v53.28c0,3.467-1.849,6.703-4.854,8.437l-46.115,26.698 C256.231,312.748,254.498,313.094,252.879,313.094z M267.095,276.457c-20.226,0-24.386-9.246-24.386-17.105 c0-0.693,0.578-1.387,1.387-1.387h6.01c0.693,0,1.271,0.462,1.271,1.156c0.925,6.126,3.583,9.13,15.834,9.13 c9.708,0,13.869-2.196,13.869-7.397c0-3.005-1.156-5.201-16.296-6.703c-12.598-1.271-20.457-4.045-20.457-14.1 c0-9.362,7.859-14.909,21.035-14.909c14.794,0,22.075,5.085,23,16.181c0,0.347-0.116,0.693-0.347,1.04 c-0.231,0.231-0.578,0.462-0.925,0.462h-6.01c-0.578,0-1.156-0.462-1.271-1.04c-1.387-6.357-4.97-8.437-14.447-8.437 c-10.633,0-11.904,3.698-11.904,6.472c0,3.352,1.502,4.392,15.834,6.241c14.216,1.849,20.919,4.507,20.919,14.447 C290.095,270.678,281.773,276.457,267.095,276.457z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M109.797,104.712c0-2.08-1.156-4.045-3.005-5.085l-49.004-28.2c-0.809-0.462-1.734-0.693-2.658-0.809 h-0.462c-0.925,0-1.849,0.347-2.658,0.809l-49.004,28.2C1.156,100.666,0,102.631,0,104.712l0.116,75.818 c0,1.04,0.578,2.08,1.502,2.543c0.925,0.578,2.08,0.578,2.889,0l29.125-16.643c1.849-1.04,3.005-3.005,3.005-5.085v-35.482 c0-2.08,1.156-4.045,3.005-5.085l12.367-7.166c0.925-0.578,1.965-0.809,3.005-0.809s2.08,0.231,2.889,0.809l12.367,7.166 c1.849,1.04,3.005,3.005,3.005,5.085v35.482c0,2.08,1.156,4.045,3.005,5.085l29.125,16.643c0.925,0.578,2.08,0.578,3.005,0 c0.925-0.462,1.502-1.502,1.502-2.543L109.797,104.712L109.797,104.712z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M345.34,0.347c-0.925-0.462-2.08-0.462-2.889,0c-0.925,0.578-1.502,1.502-1.502,2.543v75.124 c0,0.693-0.347,1.387-1.04,1.849c-0.693,0.347-1.387,0.347-2.08,0l-12.251-7.05c-1.849-1.04-4.045-1.04-5.894,0l-49.004,28.316 c-1.849,1.04-3.005,3.005-3.005,5.085v56.516c0,2.08,1.156,4.045,3.005,5.085l49.004,28.316c1.849,1.04,4.045,1.04,5.894,0 l49.004-28.316c1.849-1.04,3.005-3.005,3.005-5.085V21.844c0-2.196-1.156-4.161-3.005-5.201L345.34,0.347L345.34,0.347z M340.833,144.123c0,0.578-0.231,1.04-0.693,1.271l-16.758,9.708c-0.462,0.231-1.04,0.231-1.502,0l-16.758-9.708 c-0.462-0.231-0.693-0.809-0.693-1.271v-19.417c0-0.578,0.231-1.04,0.693-1.271l16.758-9.708c0.462-0.231,1.04-0.231,1.502,0 l16.758,9.708c0.462,0.231,0.693,0.809,0.693,1.271V144.123L340.833,144.123z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.047404, 70.501129)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M107.37,53.743c1.849-1.04,2.889-3.005,2.889-5.085V34.904c0-2.08-1.156-4.045-2.889-5.085l-48.657-28.2 c-1.849-1.04-4.045-1.04-5.894,0L3.814,29.934c-1.849,1.04-3.005,3.005-3.005,5.085v56.516c0,2.08,1.156,4.045,3.005,5.085 l48.657,27.738c1.849,1.04,4.045,1.04,5.779,0l29.472-16.412c0.925-0.462,1.502-1.502,1.502-2.543c0-1.04-0.578-2.08-1.502-2.543 L38.487,74.546c-0.925-0.578-1.502-1.502-1.502-2.543V54.321c0-1.04,0.578-2.08,1.502-2.543l15.372-8.784 c0.925-0.578,2.08-0.578,3.005,0l15.372,8.784c0.925,0.578,1.502,1.502,1.502,2.543V68.19c0,1.04,0.578,2.08,1.502,2.543 c0.925,0.578,2.08,0.578,3.005,0L107.37,53.743L107.37,53.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#539E43",
    d: "M55.014,51.084c0.347-0.231,0.809-0.231,1.156,0l9.362,5.432c0.347,0.231,0.578,0.578,0.578,1.04v10.864 c0,0.462-0.231,0.809-0.578,1.04l-9.362,5.432c-0.347,0.231-0.809,0.231-1.156,0l-9.362-5.432 c-0.347-0.231-0.578-0.578-0.578-1.04V57.557c0-0.462,0.231-0.809,0.578-1.04L55.014,51.084L55.014,51.084z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.067720, 70.501129)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path-2_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.6722,
    y1: 336.5833,
    x2: -128.0759,
    y2: 335.8606,
    gradientTransform: "matrix(108.9878 0 0 -124.186 13989.2441 41821.7031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    style: {
      stopColor: "#418B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    style: {
      stopColor: "#419637"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#3FA92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FAE2A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path-2_1_",
    fill: "url(#path-2_4_)",
    d: "M57.672,1.849c-1.849-1.04-4.045-1.04-5.894,0L3.121,29.934 c-1.849,1.04-2.889,3.005-2.889,5.085v56.285c0,2.08,1.156,4.045,2.889,5.085l48.657,28.085c1.849,1.04,4.045,1.04,5.894,0 L106.33,96.39c1.849-1.04,2.889-3.005,2.889-5.085V35.019c0-2.08-1.156-4.045-2.889-5.085L57.672,1.849L57.672,1.849z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -0.231,
    y: 1.051,
    width: 109.797,
    height: 124.353
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.231,
    y: 1.051,
    width: 109.797,
    height: 124.353,
    id: "mask-3_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2_2_",
    fill: "#FFFFFF",
    d: "M57.672,1.849c-1.849-1.04-4.045-1.04-5.894,0L3.121,29.934 c-1.849,1.04-2.889,3.005-2.889,5.085v56.285c0,2.08,1.156,4.045,2.889,5.085l48.657,28.085c1.849,1.04,4.045,1.04,5.894,0 L106.33,96.39c1.849-1.04,2.889-3.005,2.889-5.085V35.019c0-2.08-1.156-4.045-2.889-5.085L57.672,1.849L57.672,1.849z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3_1_)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M51.662,1.849L2.889,29.934c-1.849,1.04-3.121,3.005-3.121,5.085v56.285c0,1.387,0.578,2.658,1.502,3.698 L56.054,1.156C54.667,0.925,53.049,1.04,51.662,1.849L51.662,1.849z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M56.401,125.053c0.462-0.116,0.925-0.347,1.387-0.578l48.773-28.085c1.849-1.04,3.005-3.005,3.005-5.085 V35.019c0-1.502-0.693-3.005-1.734-4.045L56.401,125.053L56.401,125.053z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.9225,
    y1: 336.2061,
    x2: -126.7628,
    y2: 336.9408,
    gradientTransform: "matrix(106.4452 0 0 -124.1327 13664.0645 41803.9102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6CC04A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M106.445,29.934L57.557,1.849c-0.462-0.231-1.04-0.462-1.502-0.578L1.271,95.119 c0.462,0.578,1.04,1.04,1.618,1.387l48.888,28.085c1.387,0.809,3.005,1.04,4.507,0.578l51.431-94.079 C107.37,30.628,106.907,30.281,106.445,29.934L106.445,29.934z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -0.231,
    y: -8.437,
    width: 111.299,
    height: 135.339
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.231,
    y: -8.437,
    width: 111.299,
    height: 135.339,
    id: "mask-3_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2_3_",
    fill: "#FFFFFF",
    d: "M57.672,1.849c-1.849-1.04-4.045-1.04-5.894,0L3.121,29.934 c-1.849,1.04-2.889,3.005-2.889,5.085v56.285c0,2.08,1.156,4.045,2.889,5.085l48.657,28.085c1.849,1.04,4.045,1.04,5.894,0 L106.33,96.39c1.849-1.04,2.889-3.005,2.889-5.085V35.019c0-2.08-1.156-4.045-2.889-5.085L57.672,1.849L57.672,1.849z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -9.246050)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.566,100.551V44.265c0-2.08-1.271-4.045-3.121-5.085L57.557,11.095 c-0.578-0.347-1.156-0.578-1.849-0.693l53.512,91.42C109.45,101.475,109.566,101.013,109.566,100.551L109.566,100.551z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.889,39.18c-1.849,1.04-3.121,3.005-3.121,5.085v56.285c0,2.08,1.387,4.045,3.121,5.085l48.888,28.085 c1.156,0.693,2.427,0.925,3.814,0.693L3.236,39.065L2.889,39.18L2.889,39.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -178.9258,
    y1: 80.9064,
    x2: -81.5088,
    y2: 80.9064,
    gradientTransform: "matrix(0.9246 0 0 -0.3467 174.0923 29.0348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_2_)",
    d: "M50.16,0.809l-0.693,0.347h0.925L50.16,0.809z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -128.3992,
    y1: 345.5044,
    x2: -127.3403,
    y2: 345.5044,
    gradientTransform: "matrix(106.3296 0 0 -124.2334 13651.085 42995.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_3_)",
    d: "M106.561,105.636c1.387-0.809,2.427-2.196,2.889-3.698 L55.823,10.402c-1.387-0.231-2.889-0.116-4.161,0.693L3.121,39.065l52.356,95.465c0.693-0.116,1.502-0.347,2.196-0.693 L106.561,105.636L106.561,105.636z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -242.7413,
    y1: 232.5283,
    x2: -145.3243,
    y2: 232.5283,
    gradientTransform: "matrix(0.3467 0 0 -0.809 161.2059 292.6602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_4_)",
    d: "M111.068,104.712l-0.347-0.578v0.809L111.068,104.712z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.4465,
    y1: 343.5647,
    x2: -127.4,
    y2: 343.5647,
    gradientTransform: "matrix(55.014 0 0 -34.326 7119.8252 11912.1768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_5_)",
    d: "M106.561,105.636l-48.773,28.085 c-0.693,0.347-1.387,0.578-2.196,0.693l0.925,1.734l54.089-31.321v-0.693l-1.387-2.312 C108.988,103.44,107.948,104.827,106.561,105.636L106.561,105.636z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.1036,
    y1: 346.176,
    x2: -128.3658,
    y2: 342.0492,
    gradientTransform: "matrix(55.014 0 0 -34.326 7119.8252 11912.1768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    style: {
      stopColor: "#418B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    style: {
      stopColor: "#419637"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#3FA92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FAE2A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_6_)",
    d: "M106.561,105.636l-48.773,28.085 c-0.693,0.347-1.387,0.578-2.196,0.693l0.925,1.734l54.089-31.321v-0.693l-1.387-2.312 C108.988,103.44,107.948,104.827,106.561,105.636L106.561,105.636z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.31e01fe81263ec86dfb15111f8662a68.svg";
export { ForwardRef as ReactComponent };